export type ConstraintVisibilityUiState = {
  focus: boolean;
  constraintsVisible: boolean;
  tendonsVisible: boolean;
  labelsOff: boolean;
  tendonLabelsOff: boolean;
};

export const CONSTRAINT_VISIBILITY_UI_EVENT = "selected-constraint-visibility-options-changed";

export const DEFAULT_CONSTRAINT_VISIBILITY_UI_STATE: ConstraintVisibilityUiState = {
  focus: false,
  constraintsVisible: true,
  tendonsVisible: true,
  labelsOff: true,
  tendonLabelsOff: true,
};

let currentConstraintVisibilityUiState: ConstraintVisibilityUiState = {
  ...DEFAULT_CONSTRAINT_VISIBILITY_UI_STATE,
};

export function getConstraintVisibilityUiState(): ConstraintVisibilityUiState {
  return { ...currentConstraintVisibilityUiState };
}

export function setConstraintVisibilityUiState(
  patch: Partial<ConstraintVisibilityUiState>
): ConstraintVisibilityUiState {
  currentConstraintVisibilityUiState = {
    ...currentConstraintVisibilityUiState,
    ...patch,
  };
  dispatchConstraintVisibilityUiState(currentConstraintVisibilityUiState);
  return getConstraintVisibilityUiState();
}

export function dispatchConstraintVisibilityUiState(state: ConstraintVisibilityUiState): void {
  currentConstraintVisibilityUiState = { ...state };
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(CONSTRAINT_VISIBILITY_UI_EVENT, {
      detail: { ...state },
    })
  );
}
